import { ReactElement, useState } from 'react';
import TableRefreshHeaderFeature from 'src/app/components/features/tables/TableRefreshHeaderFeature';
import TicketLinkImportTable from 'src/app/components/tables/TicketLinkImportTable';
import {
    FETCH_TICKET_LINK_IMPORTS_QUERY_KEY,
    useFetchTicketLinkImports,
} from 'src/app/hooks/ticket-link-imports/useFetchTicketLinkImports';
import { useSpacingStyles } from 'src/shared/styles/spacingStyles';

export interface TicketLinkImportTableFeatureProps {
    bookingOptionId: string;
    onClickDetails: (importId: string) => void;
}

export default function TicketLinkImportTableFeature(
    props: Readonly<TicketLinkImportTableFeatureProps>
): ReactElement {
    const [page, setPage] = useState<number>(1);
    const spacingClasses = useSpacingStyles();

    const {
        data: fetchResult,
        isLoading: loading,
        isFetching: fetching,
    } = useFetchTicketLinkImports(props.bookingOptionId, {
        page,
    });

    const imports = fetchResult?.data.data;
    const responseMeta = fetchResult?.data.meta;

    return (
        <div className={spacingClasses.spacingTop}>
            <TableRefreshHeaderFeature queryKeys={[[FETCH_TICKET_LINK_IMPORTS_QUERY_KEY]]} />
            <TicketLinkImportTable
                ticketLinkImports={imports ?? []}
                loading={loading || fetching}
                onClickDetails={props.onClickDetails}
                pagination={{
                    currentPage: responseMeta?.currentPage || 1,
                    totalPages: responseMeta?.totalPages || 1,
                    onPaginate: setPage,
                }}
            />
        </div>
    );
}
